import { Link } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import usePromotions from "common/datahooks/usePromotions";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AgencySubscriptionCard from "../AgencySubscriptionCard";
import { LinkedInCrm, Rented } from "./SubscriptionCards";

export default function Billing() {
  const isDesktop = useTwBreakpoint("lg");
  const { agencyPlan } = usePromotions();
  const { subscription_status, lifetime_license_count } =
    useSelectedWorkspaceContext();

  return (
    <>
      <RenderIf condition={!!lifetime_license_count}>
        <Button
          variant="secondary-black"
          asChild
          size={isDesktop ? "sm" : "md"}
          className="ml-auto"
        >
          <Link to="../ltd">Lifetime seats ({lifetime_license_count})</Link>
        </Button>
      </RenderIf>
      <RenderIf
        condition={agencyPlan && agencyPlan.subscription.status !== "cancelled"}
      >
        <AgencySubscriptionCard isAgencyPage={false} />
      </RenderIf>

      <RenderIf
        condition={
          !agencyPlan ||
          agencyPlan.subscription.status === "cancelled" ||
          //if the user has no outreach subscription, subscription_status is null
          (subscription_status && subscription_status !== "cancelled")
        }
      >
        <LinkedInCrm />
      </RenderIf>
      <Rented />
    </>
  );
}
